// Google Ads se consolidó como pestaña dentro de Reportes (/reports?tab=google_ads).
// Esta ruta se conserva solo para redirigir enlaces/marcadores antiguos.

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/google-ads')({
  beforeLoad: () => {
    throw redirect({ to: '/reports', search: { tab: 'google_ads' } });
  },
});
